/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManagerSettings {
    angular.module("meevo.plugins.walkinManagerSettings", []);
}